module.exports = __webpack_public_path__ + "img/坚朗.7d72cb6d.png";